/**
 * @fileoverview Environment variable wrapper & validation
 * KURAL: Proje genelinde import.meta.env DOĞRUDAN kullanılmaz.
 *        Tüm ortam değişkenleri bu modül üzerinden erişilir.
 */

const DEV_MODE = import.meta.env.DEV

/**
 * Kritik env değişkenlerini kontrol et ve geliştirme ortamında uyar.
 * @param {string} key - Değişken adı
 * @param {string|undefined} value - Değer
 * @returns {string}
 */
function requireEnv(key, value) {
  if (!value && DEV_MODE) {
    console.warn(`[ENV] ⚠️ Eksik ortam değişkeni: ${key}. .env.example dosyasını kontrol edin.`)
  }
  return value ?? ''
}

/**
 * Geliştirme + XAMPP: tam `http://localhost/.../ankaServer/api` adresi tarayıcıda CORS (özellikle PUT
 * preflight) üretir. Vite `server.proxy` ile `/ankaServer` Apache’ye yönlendirildiği için burada
 * kökü göreli path yapıyoruz; istekler `localhost:5173` ile aynı kökenden gider.
 * @param {string} raw
 */
function normalizeApiBaseUrl(raw) {
  const s = String(raw ?? '').trim().replace(/\/+$/, '')
  if (!s) return ''
  if (DEV_MODE) {
    try {
      const u = new URL(s)
      const h = u.hostname.toLowerCase()
      const loopback = h === 'localhost' || h === '127.0.0.1' || h === '::1'
      if (loopback && /\/ankaServer(\/|$)/.test(u.pathname)) {
        return u.pathname.replace(/\/+$/, '') || '/ankaServer/api'
      }
    } catch {
      /* göreli veya geçersiz URL — olduğu gibi */
    }
  }
  return s
}

const rawApiBase = requireEnv('VITE_API_BASE_URL', import.meta.env.VITE_API_BASE_URL)

/** @type {{ APP_NAME: string, APP_ENV: string, API_BASE_URL: string, SENTRY_DSN: string, ISKUR_LICENSE: string, IS_DEV: boolean, IS_PROD: boolean }} */
export const ENV = {
  APP_NAME:      import.meta.env.VITE_APP_NAME    ?? 'GlobalAnka',
  APP_ENV:       import.meta.env.VITE_APP_ENV     ?? 'development',
  API_BASE_URL:  normalizeApiBaseUrl(rawApiBase),
  SENTRY_DSN:    import.meta.env.VITE_SENTRY_DSN  ?? '',
  ISKUR_LICENSE: import.meta.env.VITE_ISKUR_LICENSE_NO ?? '',
  IS_DEV:        import.meta.env.DEV  === true,
  IS_PROD:       import.meta.env.PROD === true,
}

// Startup log — sadece geliştirme ortamında
if (DEV_MODE) {
  console.info(`[ENV] 🚀 ${ENV.APP_NAME} — ${ENV.APP_ENV} modu`)
}
